import { render, staticRenderFns } from "./MoskitField.vue?vue&type=template&id=15882aba&"
import script from "./MoskitField.vue?vue&type=script&lang=ts&"
export * from "./MoskitField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports